import React from 'react';
import { func } from 'prop-types';

import { Elements, StripeProvider } from 'react-stripe-elements';
import FormWrapper from 'components/FormWrapper';
import countries from 'utils/countries';
import { CSS_OVERFLOW, STRIPE_PUBLIC_API_KEY } from 'utils/constants';

import InnerForm, { validationSchema } from './innerForm';

const CardForm = ({ hideModal, onSubmit }) => (
  <StripeProvider apiKey={STRIPE_PUBLIC_API_KEY}>
    <Elements>
      <FormWrapper
        formName="Add Card"
        handleSubmit={() => {}}
        initialValues={{
          city: '',
          country: '',
          line1: '',
          line2: '',
          state: '',
          postal_code: '',
          card: '',
          name: ''
        }}
        overflowBehaviour={CSS_OVERFLOW.SCROLL}
        validationSchema={validationSchema}
      >
        <InnerForm
          countries={countries}
          hideModal={hideModal}
          onSubmit={onSubmit} // We pass it here instead of on the wrapper to bypass formik limitations
        />
      </FormWrapper>
    </Elements>
  </StripeProvider>
);

CardForm.propTypes = {
  hideModal: func.isRequired,
  onSubmit: func.isRequired
};

export default CardForm;
